import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const muiV37BlackOpacity12 = 'rgba(0, 0, 0, 0.12)';
const muiv37ActionActive = 'rgba(0, 0, 0, 0.56)';
const muiV37Gray50 = '#F8F8F8';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px',
    borderRadius: '4px',
    border: `1px solid ${muiV37BlackOpacity12}`
  },
  iconContainer: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: muiV37Gray50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 3
  },
  icon: {
    width: '24px',
    height: '24px',
    color: muiv37ActionActive
  },
  title: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    marginBottom: '8px',
    color: muiv37ActionActive
  },
  description: {
    marginBottom: '32px',
    maxWidth: '770px',
    textAlign: 'center',
    color: muiv37ActionActive
  }
});
